import React from 'react'
import {
  Typography,
  Container,
  createStyles,
  withStyles,
} from '@material-ui/core'
import { getBackgroundImageStyles } from '../../styles/hero'
import ViewMore from '../ViewMore'
import Background from '../Background'

const styles = (theme) => {
  const backgroundImageStyles = getBackgroundImageStyles(theme)
  return createStyles({
    hero: {
      ...backgroundImageStyles,
      padding: '8.625rem 0 1.625rem',
      marginBottom: '8.75rem',
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    title: {
      marginBottom: '2.4375rem',
    },
    description: {
      marginBottom: '5.3125rem',
    },
  })
}

const Hero = ({ classes, sectionId, title, subtitle }) => {
  return (
    <section className={classes.hero}>
      <Background />
      <Container className={classes.container}>
        <Typography className={classes.title} variant="h1">
          {title}
        </Typography>
        <Typography variant="subtitle1" className={classes.description}>
          {subtitle}
        </Typography>
        <ViewMore id={sectionId} />
      </Container>
    </section>
  )
}

export default withStyles(styles)(Hero)
